(function () {
  if (window.__chakrikkaBlurUpInit) return;
  window.__chakrikkaBlurUpInit = true;

  function markLoaded(img) {
    img.classList.add('chakrikka-blur-up--loaded');
  }

  function init() {
    document.querySelectorAll('img.chakrikka-blur-up').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        markLoaded(img);
      } else {
        img.addEventListener('load', function onLoad() {
          img.removeEventListener('load', onLoad);
          markLoaded(img);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
